import * as React from "react";
import { useEffect, useRef, ReactNode } from 'react';
import Logo from "src/components/Logo";
import { OrderItemProps } from "src/resources/sales/interface";
import {
  Typography
} from "@mui/material";

interface FabricDetailSheetProps {
  record: OrderItemProps;
}

export const FabricDetailSheet = (props: FabricDetailSheetProps) => {
  const { record } = props
  let productParent = record.product.parent ?? record.product;

  return (
    <>
      <div className="fabric-detail-sheet__wrapper">
        <div className="fabric-detail-sheet__print-header">
          <div className="fabric-detail-sheet__header">
            <div className="fabric-detail-sheet__title">
              <Typography variant="h5">Fabric Detail Sheet <span>(fabric for decoration)</span></Typography>
            </div>
            <h5 className="fabric-detail-sheet__product-name">
              {productParent.name} {productParent.sku}
            </h5>
          </div>
          <div className="fabric-detail-sheet__print-logo">
            <Logo color="#000"/>
          </div>
        </div>
        <div className="fabric-detail-sheet__table">
          <SheetRow
            label="Harmonized tariff Code"
            value={productParent?.attributes?.htc}
          />
          <SheetRow
            label="Item name / number"
            value={`${productParent.mill_name} - ${productParent?.attributes?.mill} - 
          ${productParent.name} - ${productParent.sku}`}
          />
          <SheetRow
            label="Country of origin"
            value={productParent?.attributes?.country_of_manufacture}
          />
          <SheetRow
            label="Manufacturer address"
            value={productParent?.attributes?.manufacturer_address}
          />
          <SheetRow
            label="Percentage composition by weight"
            value={productParent?.attributes?.content}
          />
          <MultilineWrapper
            label="For content chief value is 'man made', artificial or
            syntethic fabrics, staple fibers are"
          >
            <MultilineRow
              label="Discontinuous (%):"
              value={productParent?.attributes?.fiber_discont_pc}
            />
            <MultilineRow
              label="Continuous (%):"
              value={productParent?.attributes?.fiber_cont_pc}
            />
          </MultilineWrapper>
          <SheetRow
            label="Fabric width (cm)"
            value={productParent?.attributes?.fabric_width}
          />
          <SheetRow
            label="Weight (gram/sq.meters)"
            value={productParent?.attributes?.gr_m2}
          />
          <MultilineWrapper label="Presentation type">
            <MultilineRow
              label="Carded (Y/N):"
              value={productParent?.attributes?.carded_yn}
            />
            <MultilineRow
              label="Combed (Y/N):"
              value={productParent?.attributes?.combed_yn}
            />
            <MultilineRow
              label="High tenacity (Y/N):"
              value={productParent?.attributes?.high_tenacity_yn}
            />
          </MultilineWrapper>
          <SheetRow
            label="Weave type"
            value={productParent?.attributes?.weave_type}
          />
          <MultilineWrapper label="Nb of single yarns">
            <MultilineRow
              label="Warp:"
              value={productParent?.attributes?.yarn_warp}
            />
            <MultilineRow
              label="Weft:"
              value={productParent?.attributes?.yarn_weft}
            />
            <MultilineRow
              label="Average yarn nb.:"
              value={productParent?.attributes?.yarn_avg}
            />
          </MultilineWrapper>
          <SheetRow label="Greige" value={productParent?.attributes?.greige} />
          <MultilineWrapper label="For velvet fabric">
            <MultilineRow
              label="Pile %:"
              value={productParent?.attributes?.velvet_pile_pc}
            />
          </MultilineWrapper>
          <MultilineWrapper label="For chief value cotton fabric">
            <MultilineRow
              label="Napped (Y/N):"
              value={productParent?.attributes?.cotton_napped_yn}
            />
          </MultilineWrapper>
          <MultilineWrapper label="For chief value wool fabric">
            <MultilineRow
              label="Worsted (Y/N):"
              value={productParent?.attributes?.wool_worsted_yn}
            />
            <MultilineRow
              label="Hand woven (Y/N):"
              value={productParent?.attributes?.wool_handwoven_yn}
            />
          </MultilineWrapper>
          <MultilineWrapper label="For chief value silk fabric">
            <MultilineRow
              label="Noil (Y/N):"
              value={productParent?.attributes?.silk_noil_yn}
            />
            <MultilineRow
              label="Silk waste (Y/N):"
              value={productParent?.attributes?.silk_waste_yn}
            />
          </MultilineWrapper>
        </div>
        <div className="fabric-detail-sheet__notice">
          PLEASE NOTE THAT FALIURE TO PROVIDE COMPLETE AND ACCURATE INFORMATION ON THIS DOCUMENT WILL DELAY ENTRY OF GOOD TO CUSTOMS AND SHIPPER WILL INCUR CHARGEBACK PER OUR POLICY
        </div>
      </div>
    </>
  );
};

const MultilineRow = ({ label, value }: any) => {
  return (
    <div className="fabric-detail-sheet__multiline-table-row">
      <p className="fabric-detail-sheet__multiline-row-subtitle">{label}</p>
      {value ? <p>{value}</p> : null}
    </div>
  );
};

const MultilineWrapper = ({ label, children }: MultilineProps) => {
  return (
    <div className="fabric-detail-sheet__multiline-row">
      <p className="fabric-detail-sheet__multiline-row-title">{label}:</p>
      {children}
    </div>
  );
};

const SheetRow = ({ label, value }: any) => {
  return (
    <div className="fabric-detail-sheet__table-row">
      <p className="fabric-detail__row-title">{label}:</p>
      {value ? <p>{value}</p> : null}
    </div>
  );
};

interface MultilineProps {
  label: string;
  children: ReactNode;
}
